import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { ReducerMenuState, menuReducer } from './menu.reducer';

export const featureStateName = 'menuFeature';

export interface MenuState {
  menu: ReducerMenuState
}

export const menuReducers: ActionReducerMap<MenuState> = {
  menu: menuReducer
};

export const getMenuFeatureState = createFeatureSelector<MenuState>(
  featureStateName
);

export const getAllMenuItems = createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.items
);

export const getAllAdminUrlsMenuItems = createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.adminUrls
);

export const getAllInstitutionUrlsMenuItems = createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.institutionUrls
);

export const getAllHiddenMenuItems = createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.items.filter(item => item.hide)
);

export const getIsSuperUser = createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.isSuperuser
);

export const getIsInstitution = createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.isInstitutionAdmin
);

export const getMenuItemByTitle = (title: string) => createSelector(
  getMenuFeatureState,
  (state: MenuState) => state.menu.items.find(item => item.title.toLowerCase() === title.toLowerCase())
);
